module.exports = __webpack_public_path__ + "static/media/10.85152ad8.jpg";